<sw-page class="topdata-login-attempt-log-detail">
    <template #smart-bar-header>
        <h2>{{ $tc('TopdataContactLoginSW6.loginLog.detail.title') }}</h2>
    </template>

    <template #smart-bar-actions>
        <sw-button @click="$router.push({ name: 'topdata.contact.login.attempt.log.list' })">
            {{ $tc('global.default.back') }}
        </sw-button>
    </template>

    <template #content>
        <sw-card-group v-if="item">
            <sw-card :title="$tc('TopdataContactLoginSW6.loginLog.detail.card.logInfo')">
                <sw-description-list>
                    <dt>{{ $tc('TopdataContactLoginSW6.loginLog.detail.label.email') }}</dt>
                    <dd>{{ item.email }}</dd>

                    <dt>{{ $tc('TopdataContactLoginSW6.loginLog.detail.label.attemptType') }}</dt>
                    <dd>{{ getAttemptTypeLabel(item.attemptType, item.contactId, item.customerId) }}</dd>

                    <dt>{{ $tc('TopdataContactLoginSW6.loginLog.detail.label.success') }}</dt>
                    <dd>
                        <sw-badge :variant="getSuccessVariant(item.success)">
                            {{ getSuccessLabel(item.success) }}
                        </sw-badge>
                    </dd>

                    <template v-if="item.errorMessage && !item.success">
                        <dt>{{ $tc('TopdataContactLoginSW6.loginLog.detail.label.errorMessage') }}</dt>
                        <dd>{{ getErrorMessageLabel(item.errorMessage) }}</dd>
                    </template>

                    <dt>{{ $tc('TopdataContactLoginSW6.loginLog.detail.label.createdAt') }}</dt>
                    <dd>
                        <sw-time-ago
                            :date="item.createdAt"
                            :date-time-format="{ month: '2-digit', day: '2-digit' }"
                        />
                    </dd>

                    <template v-if="item.ipAddress">
                        <dt>{{ $tc('TopdataContactLoginSW6.loginLog.detail.label.ipAddress') }}</dt>
                        <dd>{{ item.ipAddress }}</dd>
                    </template>

                    <template v-if="item.userAgent">
                        <dt>{{ $tc('TopdataContactLoginSW6.loginLog.detail.label.userAgent') }}</dt>
                        <dd class="login-attempt-log-user-agent">{{ item.userAgent }}</dd>
                    </template>
                </sw-description-list>
            </sw-card>

            <sw-card
                v-if="item.customer"
                :title="$tc('TopdataContactLoginSW6.loginLog.detail.card.customerInfo')"
            >
                <sw-description-list>
                    <dt>{{ $tc('TopdataContactLoginSW6.loginLog.detail.label.customerName') }}</dt>
                    <dd>{{ item.customer.firstName }} {{ item.customer.lastName }}</dd>

                    <dt>{{ $tc('TopdataContactLoginSW6.loginLog.detail.label.customerEmail') }}</dt>
                    <dd>{{ item.customer.email }}</dd>
                </sw-description-list>
            </sw-card>
        </sw-card-group>

        <sw-loader v-else-if="isLoading" />

        <sw-empty-state
            v-else
            :title="$tc('TopdataContactLoginSW6.loginLog.detail.notFound')"
        />
    </template>
</sw-page>
